<form class="email-notifications" [formGroup]="form" (ngSubmit)="saveNotificationSettings(form)">
  <div class="content">
    <h2 class="content-header" translate="account-settings-panel_email-notifications"></h2>
    @if (user.email) {
      <span
        class="content-subheader with-email"
        translate="account-settings-panel_email-notification-text"
      [translateParams]="{email: user.email}"></span>
    }

    <section class="content-body">
      @if (user.email) {
        @if (assignment_submitted_email_frequency && hasReviewerRoleOrHigher()) {
          <mat-form-field class="assignment-submitted-email-frequency-field" appearance="outline">
            <mat-label translate="account-settings-panel_unviewed-assignment-submissions"></mat-label>
            <mat-select
              formControlName="assignment_submitted_email_frequency"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (frequency of frequenciesNotImmediately; track frequency) {
                <mat-option
                  [value]="frequency">
                  {{ frequency.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        }
        @if (feedback_submitted_email_frequency) {
          <mat-form-field class="feedback-submitted-email-frequency-field" appearance="outline">
            <mat-label translate="account-settings-panel_unviewed-feedback"></mat-label>
            <mat-select
              formControlName="feedback_submitted_email_frequency"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (frequency of frequenciesNotImmediately; track frequency) {
                <mat-option
                  [value]="frequency">
                  {{ frequency.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        }
        @if (hasPresenterRole()) {
          @if (new_assignment_email_frequency) {
            <mat-form-field class="new-assignment-email-frequency-field" appearance="outline">
              <mat-label translate="account-settings-panel_new-assignment"></mat-label>
              <mat-select
                formControlName="new_assignment_email_frequency"
                disableOptionCentering
                panelClass="offsetPanel">
                @for (frequency of frequenciesNotImmediately; track frequency) {
                  <mat-option
                    [value]="frequency">
                    {{ frequency.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          }
          @if (assignment_due_email_frequency && !isLti()) {
            <mat-form-field class="assignment-due-email-frequency-field" appearance="outline">
              <mat-label translate="account-settings-panel_assignment-due"></mat-label>
              <mat-select
                formControlName="assignment_due_email_frequency"
                disableOptionCentering
                panelClass="offsetPanel">
                @for (frequency of frequenciesNotWeekly; track frequency) {
                  <mat-option
                    [value]="frequency">
                    {{ frequency.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          }
          @if (assignment_graded_email_frequency) {
            <mat-form-field class="assignment-graded-email-frequency-field" appearance="outline">
              <mat-label translate="account-settings-panel_assignment-graded"></mat-label>
              <mat-select
                formControlName="assignment_graded_email_frequency"
                disableOptionCentering
                panelClass="offsetPanel">
                @for (frequency of frequenciesNotHourly; track frequency) {
                  <mat-option
                    [value]="frequency">
                    {{ frequency.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
            </mat-form-field>
          }
        }
      }
    </section>
  </div>

  @if (shouldShowSaveButton$ | async) {
    <div class="content-footer">
      <button
        class="primary-btn submit-btn"
        type="submit"
        translate="common_save-changes">
      </button>
    </div>
  }
</form>
